import { render, staticRenderFns } from "./courseDataUpload.vue?vue&type=template&id=4e0a040d&scoped=true&"
import script from "./courseDataUpload.vue?vue&type=script&lang=js&"
export * from "./courseDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./courseDataUpload.vue?vue&type=style&index=0&id=4e0a040d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a040d",
  null
  
)

export default component.exports